import React, { useState, ReactElement } from 'react';
import { Head } from '@ecommerce/nest-ssr/components';
import { setCookie } from 'helpers/cookie';
import AdultContainer from 'components/adult-guard/components/adult-container/adult-container';

type AdultGuardProps = {
    isEnabled: boolean;
    isBlocked: boolean;
    children: React.ReactNode;
};

const AdultGuard: React.FC<(AdultGuardProps)> = ({ isEnabled, isBlocked, children }): ReactElement | any => {
    const [blocked, setBlocked] = useState(isBlocked);

    const agree = (): void => {
        setCookie('adult', 'ok', { expiresDays: 30, path: '/', secure: true });
        setBlocked(false);
    };

    const disagree = (): void => {
        window.location.href = '/';
    };

    if (isEnabled === false) {
        return children;
    }

    return (
        <>
            <Head>
                <meta name="rating" content="adult" />
                <meta property="product:age_group" content="adult" />
            </Head>

            { blocked === true && <AdultContainer agree={agree} disagree={disagree} /> }
            { blocked === true && React.Children.map(children, (el: any) => React.cloneElement(el, { style: { display: 'none' } }))}
            { blocked === false && children }
        </>
    );
};

export default AdultGuard;
